export const spacing = {
  0: "0px",
  px: "1px",
  0.5: "2px",
  1: "4px",
  1.5: "6px",
  2: "8px",
  2.5: "10px",
  3: "12px",
  3.5: "14px",
  4: "16px",
  5: "20px",
  6: "24px",
  7: "28px",
  8: "32px",
  9: "36px",
  10: "40px",
  11: "44px",
  12: "48px",
  14: "56px",
  16: "64px",
  20: "80px",
  24: "96px",
  28: "112px",
  32: "128px",
  36: "144px",
  40: "160px",
  44: "176px",
  48: "192px",
  52: "208px",
};

export const fontSize = {
  1: "11px",
  2: "12px",
  3: "13px",
  4: "14px",
  5: "16px",
  6: "18px",
  7: "20px",
  8: "22px",
  9: "24px",
  10: "28px",
  11: "34px",
};

export const borderRadius = {
  1: "2px",
  2: "4px",
  3: "6px",
  4: "8px",
  5: "12px",
  6: "14px",
  7: "16px",
  8: "18px",
  9: "20px",
};

export const lineHeight = {
  1: "16px",
  2: "18px",
  3: "20px",
  4: "20px",
  5: "22px",
  6: "24px",
  7: "26px",
  8: "28px",
  9: "30px",
  10: "36px",
  11: "40px",
};

export const fontWeight = {
  light: "300",
  regular: "400",
  medium: "500",
  bold: "600",
};

export const letterSpacing = {
  1: "0.025em",
  2: "0.015em",
  3: "0.015em",
  4: "0.01em",
  5: "0em",
  6: "0em",
  7: "0em",
  8: "0em",
  9: "-0.01em",
  10: "-0.01em",
  11: "-0.01em",
};

export const borderWidth = {
  0: "0px",
  1: "1px",
};
